<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.7812 12.7852C17.0273 13.0586 17.0273 13.4688 16.7812 13.7148L14.5938 15.9023C14.4844 16.0391 14.3203 16.0938 14.1562 16.0938C13.9648 16.0938 13.8008 16.0391 13.6914 15.9023C13.418 15.6562 13.418 15.2461 13.6914 15L14.7578 13.9062H11.75C11.5586 13.9062 11.3945 13.8516 11.2852 13.7148L7.97656 10.4062H3.65625C3.27344 10.4062 3 10.1328 3 9.75C3 9.39453 3.27344 9.09375 3.65625 9.09375H7.97656L11.2578 5.8125C11.3945 5.67578 11.5586 5.59375 11.75 5.59375H14.7578L13.6914 4.52734C13.418 4.28125 13.418 3.87109 13.6914 3.625C13.9375 3.35156 14.3477 3.35156 14.6211 3.625L16.8086 5.8125C17.0547 6.05859 17.0547 6.46875 16.8086 6.71484L14.6211 8.90234C14.4844 9.03906 14.3203 9.09375 14.1562 9.09375C13.9648 9.09375 13.8008 9.03906 13.6914 8.90234C13.418 8.65625 13.418 8.24609 13.6914 8L14.7578 6.90625H12.0234L9.17969 9.75L12.0234 12.5938H14.7578L13.6914 11.5273C13.418 11.2812 13.418 10.8711 13.6914 10.625C13.9375 10.3516 14.3477 10.3516 14.6211 10.625L16.7812 12.7852Z"
      fill="currentColor"
    />
  </svg>
</template>
